var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import '@styles/webdesktop/stylesheets/button.scss';
import { forwardRef } from 'react';
import { Height } from '@front/sharedcomponents/Variables';
import { ButtonTypeClass } from './ButtonType';
import { SvgIcon } from '../SvgIcon/SvgIcon';
import { Typography } from '../Typography/Typography';
import { TypographyLevel } from '../Typography/TypographyLevel';
export const Button = forwardRef((_a, ref) => {
    var { type, text, className = '', height = Height.MD, disabled = false, icon = null, iconPosition = 'start', onClick } = _a, restProps = __rest(_a, ["type", "text", "className", "height", "disabled", "icon", "iconPosition", "onClick"]);
    const buttonClassName = ['button', ButtonTypeClass[type], height, className].filter(Boolean).join(' ');
    const iconClassName = ['button-icon'].filter(Boolean).join(' ');
    const iconElem = _jsx(SvgIcon, { icon: icon, className: iconClassName });
    return (_jsxs("button", Object.assign({ ref: ref, className: buttonClassName, onClick: onClick, disabled: disabled }, restProps, { children: [iconPosition === 'start' && iconElem, _jsx(Typography, { level: TypographyLevel.BodyMd, noWrap: true, children: text }), iconPosition === 'end' && iconElem] })));
});
